import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { OktaLogo } from '@/components/okta-logo';

export const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authState?.isAuthenticated) {
      navigate('/dashboard');
    }
  }, [authState, navigate]);

  const handleLogin = async () => {
    await oktaAuth.signInWithRedirect();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-4">
          <div className="flex justify-center">
            <OktaLogo className="h-12" />
          </div>
          <CardTitle className="text-2xl">Okta MCP Adapter</CardTitle>
          <CardDescription>
            Admin Console - Sign in with your Okta credentials
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            onClick={handleLogin}
            className="w-full"
            size="lg"
          >
            Sign in with Okta
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
